    export const view = {
        namespaced: true,
        state: {
            zipImages: {},
        },
    mutations: {
        SET_ZIP_STATE(state, payload) {
            const { zipFilename, index, fileName } = payload

            state.zipImages = {
                ...state.zipImages,
                [zipFilename]: { index, fileName }
            }

            const keys = Object.keys(state.zipImages)

            if (keys.length > 20) {
                delete state.zipImages[keys[0]]
            }
        }
    }
};
